<template>
  <v-container class="pa-4 hall-of-fame">
    <!-- Header -->
    <v-row align="center" class="mb-4">
      <v-btn icon>
        <v-icon @click="$router.push({ name: 'leaderboard' })">mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <h2 class="white--text font-weight-bold mr-8">Hall of Fame</h2>
      <v-spacer></v-spacer>
    </v-row>

    <!-- Year & Month Selection -->
    <v-row justify="center" class="mb-4">
      <v-btn icon @click="prevYear" :disabled="selectedYear <= minYear">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <h2 class="white--text">{{ selectedYear }}</h2>
      <v-btn icon @click="nextYear" :disabled="selectedYear >= currentYear">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-row>    
    <v-row justify="center" class="mb-6">
        <v-slide-group v-model="selectedMonth" class="month-toggle" center-active mandatory @change="fetchData">
            <v-slide-item v-for="month in months" :key="month" :value="month" v-slot="{ active, toggle }" >
                <v-btn class="ma-1" :class="{ 'active': selectedMonth === month }" @click="toggle" >
                    {{ month }}
                </v-btn>
            </v-slide-item>
        </v-slide-group>
    </v-row>

    <!-- Dynamic Sections -->
    <div v-if="hallOfFame && Object.keys(hallOfFame).length > 0">
        <div v-for="(people, category) in hallOfFame" :key="category">
            <h3 class="section-title mt-6 mb-3">
                    <popular-icon v-if="category == 'popular_creators'" /> 
                    <rising-star v-if="category == 'rising_stars'" />
                    <streamer-icon v-if="category == 'streamers'" />
                    <tipper-icon v-if="category == 'top_tippers'" />
                    <moderator-icon v-if="category == 'moderators'" />
                {{ formatCategory(category) }}
            </h3>
            <div v-for="(person, i) in people" :key="category + '-' + i" class="person-card">
                <div class="person-card-title">
                <profile-image
                    v-if="person.profileImage"
                    :img="person.profileImage"
                    :id="person.user.id"
                    :username="person.user.name || ''"
                    :is-exist-story="person.creatorHasStories"
                    :has-not-watched-stories="person.hasNotWatchedStories"
                    :size="40"
                    :fontSize="18"
                    :border="!person.creatorHasStories ? 1 : 2"
                    class="profile-image"
                    :view-profile="true"
                    :view-profile-from="'hallfames'"
                    :view-profile-slug="person.user.slug || ''"
                />
               <span class="name">{{ (person.user && person.user.name) || 'N/A' }}</span>
              </div>
              <div class="badge" :class="'badge-' + person.rank">
                <rank-first v-if="person.rank == 1"/>
                <rank-second v-if="person.rank == 2"/>
                <rank-third v-if="person.rank == 3"/>               
              </div>
            </div>
        </div>
    </div>
    <div v-else class="d-flex align-center justify-center h-100 mt-4">
        No Data Found
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.common.js";
import PopularIcon from "@/components/app/icons/PopularIcon";
import RisingStar from "@/components/app/icons/RisingStarIcon";
import StreamerIcon from "@/components/app/icons/StreamerIcon";
import TipperIcon from "@/components/app/icons/TipperIcon";
import ModeratorIcon from "@/components/app/icons/ModeratorIcon";
import RankFirst from "@/assets/images/icons/rank-first.svg?inline";
import RankSecond from "@/assets/images/icons/rank-second.svg?inline";
import RankThird from "@/assets/images/icons/rank-third.svg?inline";
import ProfileImage from "@/components/app/profile/ProfileImage";

export default {
    name: "HallFames",
    components: {PopularIcon, RisingStar, StreamerIcon, TipperIcon, RankFirst, RankSecond, RankThird, ModeratorIcon, ProfileImage},
    data() {
      return {
        currentYear: new Date().getFullYear(),
        selectedYear: new Date().getFullYear(),
        minYear: 2025,
        selectedMonth: "",
        months: [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ],
        hallOfFame: {}
      };
    },
    watch: {
        selectedYear() {
            this.fetchData();
        }
    },
    mounted() {
        this.getPreviousThreeMonths();
        this.fetchData();
    },
    methods: {
        ...mapActions(["getHallFames"]),
        getPreviousThreeMonths() {
            const months = [];
            const monthNames = [
                "January","February","March","April","May","June",
                "July","August","September","October","November","December"
            ];

            let now = new Date();
            let currentMonth = now.getMonth();

            let thirdPrevMonth = new Date(now.getFullYear(), currentMonth - 3, 1);
            this.selectedMonth = monthNames[thirdPrevMonth.getMonth()];
        },
        async fetchData() {
            try {
                const response = await this.getHallFames( {
                    year: this.selectedYear,
                    month: this.selectedMonth
                });
                this.hallOfFame = response || {};
            } catch (error) {
                console.error("Error fetching hall of fame data:", error);
            }
        },
        prevYear() {
            if (this.selectedYear > this.minYear) {
                this.selectedYear--;
            }
        },
        nextYear() {
            if (this.selectedYear < this.currentYear) {
                this.selectedYear++;
            }
        },
        formatCategory(category) {
            if (!category) return '';
            return category.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }
    }
};
</script>

<style scoped>
.month-toggle { display: flex; gap: 10px; }
.theme--dark.v-btn-toggle:not(.v-btn-toggle--group.month-toggle) .v-btn.v-btn { border: 1px solid rgba(255, 255, 255, 0.2); }
.month-toggle button { height: 34px !important; font-size: 16px; font-weight: 500; line-height: 1; text-transform: capitalize;
 border-radius: 8px !important; border: 1px solid rgba(255, 255, 255, 0.2); padding: 8px 25px !important; }
/* .theme--dark.v-btn-toggle:not(.v-btn-toggle--group.month-toggle) .v-btn.v-btn.active { background: rgba(255, 120, 5, 0.16) !important; border: 1.5px solid rgba(255, 120, 5, 1) !important; }  */
.month-toggle .v-btn--contained.active { background: rgba(255, 120, 5, 0.16) !important; border: 1.5px solid rgba(255, 120, 5, 1) !important; } 
.v-application--is-ltr .v-btn-toggle.month-toggle > .v-btn.v-btn:not(:first-child) { border-left-width: 1px; }

h3.section-title { display: flex; align-items: center; justify-items: flex-start; gap: 16px; font-weight: 700; font-size: 24px; line-height: 160%; }

.person-card { display: flex; align-items: center; gap: 10px; background: rgba(23, 23, 23, 1); border: 1px solid rgba(255, 255, 255, 0.05); border-radius: 8px; padding: 13px 15px; margin-bottom: 8px; }
.person-card:last-child { margin-bottom: 0; }
.person-card .person-card-title { width: calc(100% - 40px); display: flex; align-items: center; gap: 10px; }
.person-card .badge { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; }

</style>
